import { render, staticRenderFns } from "./ArticlePosterForm.vue?vue&type=template&id=1e79512d&"
import script from "./ArticlePosterForm.vue?vue&type=script&lang=js&"
export * from "./ArticlePosterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports